<generic-grid [gridData]="gridData" [gridColumns]="gridColumns"> </generic-grid>
